<template>
   <b-col>
        <b-row>
            <h3 class="ml-3">Zusatz-EAN einfügen</h3>
        </b-row>
        <b-row class="my-2">
            <b-col>
                <b-form-input v-model="request.asin" placeholder="ASIN"></b-form-input>
            </b-col>
            <b-col>
                <b-form-input v-model="request.ean" placeholder="EAN"></b-form-input>
            </b-col>
            <b-col class="col-2 ml-2 pl-1">
                <b-col/>
                <b-col class="p-0">
                <b-button block size="md" @click="execute()" variant="primary">
                    <span>einfügen</span>
                </b-button>
                </b-col>
                <b-col/>
            </b-col>
        </b-row>
        <b-modal
            v-model="modalError.state"
            size="md"
            centered
            dismissible
            title="Fehler"
        >
            {{modalError.message}}
        </b-modal>
    </b-col>
</template>
<script>
export default {
    name: "AdditionalEanInserter",
    data() {
        return {
            request: {
                ean: null,
                asin: null
            },
            modalError: {
                state: false,
                message: ""
            }
        }
    },
    methods: {
        validateRequest() {
            let eanPattern = RegExp('\\d{12,13}');
            let asinPattern = RegExp("^[a-z,A-Z,0-9]{10}$");
            if(this.request.ean == null) {
                this.modalError = {
                     state: true,
                     message: "EAN fehlt."
                 }
                 return false;     
            }else if(this.request.asin == null) {
                this.modalError = {
                     state: true,
                     message: "ASIN fehlt."
                 }
                 return false;       
            } else if(this.request.ean.length < 12) {
                 this.modalError = {
                     state: true,
                     message: "EAN zu kurz"
                 }
                 return false;
            } else if (this.request.ean.length > 13){
                 this.modalError = {
                     state: true,
                     message: "EAN zu lang."
                 }
                            return false;
            }else if (this.request.asin.length !== 10) {
                 this.modalError = {
                     state: true,
                     message: "ASIN falsche länge."
                 }
                               return false;
            }else if (!asinPattern.test(this.request.asin)) {
                 this.modalError = {
                     state: true,
                     message: "ASIN nicht alphanumerisch."
                 }
                return false;
            }else if (!eanPattern.test(this.request.ean)) {
                 this.modalError = {
                     state: true,
                     message: "EAN muss numerisch sein."
                 }
                return false;
            }
            return true;
        },
        execute() {
            if(!this.validateRequest()) return;
            axios.post('/additionaleaninserter/execute', this.request ).then( response => {
                this.request = { ean: null, asin: null };
            }).catch( error => {
                this.modalError.state = true;
                if(error.response.status == 409) {
                    this.modalError.message = "EAN existiert bereits.";
                }else if (error.response.status == 404) {
                    this.modalError.message = "Material mit der angegebenen ASIN konnte nicht gefunden werden.";
                }else{
                    this.modalError.message = "Unbekannter Fehler. Error: ".  JSON.stringify(error.response)
                }
            });
        }
    }
}
</script>
